import { render, staticRenderFns } from "./adnav.vue?vue&type=template&id=1963d494"
import script from "./adnav.vue?vue&type=script&lang=js"
export * from "./adnav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports